export const WORK_ORDERS_WIDGET_NAMESPACE = 'widget.work-orders'
